import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL_WHATSAPP_EVOLUTION;
const API_KEY = process.env.REACT_APP_API_KEY_WHATSAPP_EVOLUTION;

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json", apikey: API_KEY },
});

const apiWhatsapp = {
  createInstance: (options = {}) => {

    return apiClient.post("/instance/create", {
      ...options,
    })
  },

  connectionStateInstances: (name) => apiClient.get(`/instance/connectionState/${name}`),
  connectInstances: (name) => apiClient.get(`/instance/connect/${name}`),


  getInstances: () => apiClient.get("/instance/fetchInstances"),

  getInstance: (name) => apiClient.get(`/instance/${name}`),

  updateInstance: (name, options) => apiClient.put(`/instance/${name}`, options),

  deleteInstance: (name) => apiClient.delete(`/instance/delete/${name}`),

  logoutInstance: (name) => apiClient.delete(`/instance/logout/${name}`),

  restartInstance: (name) => apiClient.post(`/instance/restart/${name}`),

  updateWebhookOptions: (name, options) =>
    apiClient.post(`/webhook/set/${name}`, { webhook: options }),

  getWebhookExternal: (instanceName) =>
    apiClient
      .get(`/webhook/find/${instanceName}`)
      .then((res) => res.data),

  updateWebhookExternal: (instanceName, payload) =>
    apiClient.post(
      `/settings/set/${instanceName}`,
      { webhook: payload },
    ),
  postSettings: (instanceName, payload) => {
    return apiClient.post(
      `/settings/set/${instanceName}`,
      payload
    );
  }
};

export default apiWhatsapp;
